<template>
  <slot>
    <div :class="wrapperClasses" :id="identifier" v-show="!state.hidden">
      <label class="govuk-label" :for="controlId" v-show="!state.hiddenLabel" v-html="displayName"> </label>
      <div :id="titleId" class="govuk-title" v-html="displayTitle"></div>

      <div :class="displayHintClasses" v-if="displayHint" v-on:click="toggleHintSection" v-html="displayHintText"></div>
      <div :id="hintId" class="govuk-hint" v-show="!state.hiddenHint" v-html="displayHint"></div>

      <span :id="errorId" class="govuk-error-message" v-show="!state.isValid">
        <ul v-if="currentErrors.length > 0">
          <li v-for="(errorMessage, errIndex) in currentErrors" v-bind:key="errIndex">
            {{ errorMessage.message }}
          </li>
        </ul>
      </span>
      <input
        :id="controlId"
        type="text"
        :name="controlId"
        title=""
        :disabled="state.readOnly"
        :aria-describedby="hintId"
        class="govuk-input"
        v-on:blur="focusOut()"
        v-model="state.value"
        v-on:input="inputFunction($event)"
        :placeholder="displayPlaceholder"
      />
      <div :id="optionsBoxId" v-show="state.optionsOpen" class="autocomplete-items">
        <template v-for="option in state.displayedOptions" :key="option.Value">
          <div v-on:click="selectOption(option)">{{ option.Text }}</div>
        </template>
      </div>
    </div>
  </slot>
</template>
<script lang="ts" src="@/library/templates/default/controls/Autocomplete.ts"></script>
